"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUuidUnlockedForCurrentMinute = isUuidUnlockedForCurrentMinute;
const convertUuidToRandomNumberInRange_1 = require("./convertUuidToRandomNumberInRange");
function isUuidUnlockedForCurrentMinute(uuid) {
    const currentMinute = new Date().getMinutes();
    // Random number from 0 to 59 consistent for uuid
    const uuidConstantRandom = (0, convertUuidToRandomNumberInRange_1.convertUuidToRandomNumberInRange)(uuid, 60);
    // Checking if the uuid converted to 0-59 number is lower than the current minute
    // Examples for minute 42:
    // uuid random number equals 33 - unlocked - returns true
    // uuid random number equals 47 - locked - returns false
    return uuidConstantRandom <= currentMinute;
}
//# sourceMappingURL=isUuidUnlockedForCurrentMinute.js.map